import { ComponentLink } from 'common/link/link-component';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context';
import { useContext } from 'react';
import { useAppSelector } from 'redux-state/configure-store';
import { isOneCol } from 'utilities/media-queries';

export const AdvertiseWithMetService = () => {
  const isMap = !!useAppSelector((state) => state.LAYOUT.screen.layout.map);
  const isMobile = isOneCol(useContext(ScreenSizeContext));

  if (isMap && !isMobile) return null;

  return (
    <ComponentLink
      url="https://about.metservice.com/weather-for-business/advertise-with-us/advertising/"
      urlClasses="u-flex u-flexJustifyCenter"
    >
      <div className="u-text-sm u-textWhite u-textBold u-mT-xs u-mB-xxs" style={{ opacity: 0.8 }}>
        Advertise with MetService
      </div>
    </ComponentLink>
  );
};
